import { gql } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import {
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNode as LayoutNodeEntity,
  UpdateLayoutNodeInput,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { default as LayoutNode } from "../../data/model/LayoutNode";
import { AsyncLayoutActionDefinition } from "../types";
import LayoutNodeModel from "../../data/model/LayoutNode";
import { LayoutNodeFilterDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const swapLayoutNodesMutation = gql`
  ${LayoutNodeFilterDeepNestingFragment}
  ${LayoutNodeLinkDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  mutation UpdateLayoutNodePositions(
    $layoutId: ID!
    $input: [UpdateLayoutNodeInput!]!
  ) {
    updateLayoutNodePositions(layoutId: $layoutId, input: $input) {
      ...LayoutNodeDeepNesting
    }
  }
`;

export const updateLayoutNodePositionDefinition =
  new AsyncLayoutActionDefinition<
    LayoutNodeEntity,
    LayoutNodeModel,
    (
      database: Database,
      layoutId: string,
      updateLayoutNodePositionsInput: UpdateLayoutNodeInput[]
    ) => Promise<any>,
    (
      layoutId: string,
      updateLayoutNodePositionsInput: UpdateLayoutNodeInput[]
    ) => Promise<any>
  >({
    localAction: async (
      database: Database,
      layoutId: string,
      updateLayoutNodePositionsInput: UpdateLayoutNodeInput[]
    ) => {
      await database.write(async () => {
        const batch = [];

        for (const input of updateLayoutNodePositionsInput) {
          const layoutNode = await database.collections
            .get<LayoutNode>("layout_nodes")
            .find(input.id);

          batch.push(
            layoutNode.prepareUpdate((layoutNode) => {
              layoutNode.position = input.position;
            })
          );
        }
        await database.batch(batch);
      });
    },
    remoteAction: async (
      layoutId: string,
      updateLayoutNodePositionsInput: UpdateLayoutNodeInput[]
    ) => {
      const result = await client.mutate({
        mutation: swapLayoutNodesMutation,
        variables: {
          layoutId: layoutId,
          input: updateLayoutNodePositionsInput,
        },
      });

      return result.data.updateLayoutNodePositions;
    },
  });
